/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { projectImportPreviewsControllerCreate } from "./projectImportPreviewsControllerCreate";
import { projectImportsControllerCreate } from "./projectImportsControllerCreate";
import { projectsControllerAddViewer } from "./projectsControllerAddViewer";
import { projectsControllerBulkCreate } from "./projectsControllerBulkCreate";
import { projectsControllerBulkUpdate } from "./projectsControllerBulkUpdate";
import { projectsControllerCreate } from "./projectsControllerCreate";
import { projectsControllerFindAll } from "./projectsControllerFindAll";
import { projectsControllerFindByScopeId } from "./projectsControllerFindByScopeId";
import { projectsControllerFindOne } from "./projectsControllerFindOne";
import { projectsControllerRemove } from "./projectsControllerRemove";
import { projectsControllerUpdate } from "./projectsControllerUpdate";
import { projectsControllerUpdateVisibility } from "./projectsControllerUpdateVisibility";

export function projectsService() {
  return { projectsControllerCreate, projectsControllerFindAll, projectsControllerBulkCreate, projectsControllerBulkUpdate, projectsControllerAddViewer, projectsControllerFindOne, projectsControllerUpdate, projectsControllerRemove, projectsControllerFindByScopeId, projectsControllerUpdateVisibility, projectImportPreviewsControllerCreate, projectImportsControllerCreate }
}